import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaAlignRight } from "react-icons/fa";
import PropTypes from 'prop-types';

const logo = "https://wildlife-investments-prod-images.s3.us-east-2.amazonaws.com/wildlifeinvestments-horizontalgrey-nobackground.png";

function Navbar({ isMobile, currentProfile }) {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle =() => {
        if(isMobile) {
            if(!isOpen) {
                document.querySelector("#myNavbar").className = "w3-bar w3-white w3-wide w3-padding w3-card";
            } else {
                document.querySelector("#myNavbar").className = "w3-bar w3-wide w3-padding";
            }
            setIsOpen(!isOpen);
        }
    }

    useEffect(() => {
        handleScroll();
        
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleScroll = () => {
        const position = window.pageYOffset;
        if (position < 20 && !isOpen) {
            document.querySelector("#myNavbar").className = "w3-bar w3-wide w3-padding";
        } else {
            document.querySelector("#myNavbar").className = "w3-bar w3-white w3-wide w3-padding w3-card";
        }
    };

    return (
        <nav className="navbar">
            <div className="nav-center">
                <div className="w3-top">
                    <div id="myNavbar" className="w3-bar w3-wide w3-padding w3-card">
                        <div style={isMobile ? { "display": "flex" } : {}}>
                            <Link style={{ "padding": "0px", "paddingRight": "75px" }} className="w3-bar-item w3-button" to="/"  onClick={() => { if(isOpen) { handleToggle(); }}}>
                                <img
                                    style={{ "maxWidth": "150px" }}
                                    src={logo}
                                    alt="Vale Outdoors"
                                />
                            </Link>
                            <button
                                type="button"
                                style={{"width":"85%", "marginTop":"8px"}}
                                className="nav-btn"
                                onClick={() => handleToggle()}
                            >
                                <FaAlignRight className="nav-icon" />
                            </button>
                        </div>
                        <div className={isOpen ? "" : "w3-right w3-hide-small"}>
                            {isMobile && isOpen && currentProfile ? (
                                <React.Fragment>
                                    <Link to={`/account/${currentProfile.sub}`} className={isOpen ? "nav-links" : "w3-bar-item w3-button"} onClick={() => handleToggle()}>Account</Link>
                                    {currentProfile.isAdmin ? (
                                        <Link to="/users/privileges" className={isOpen ? "nav-links" : "w3-bar-item w3-button"} onClick={() => handleToggle()}>User Privileges</Link>
                                    ) : null}
                                    <Link to="/logout" className={isOpen ? "nav-links" : "w3-bar-item w3-button"} onClick={() => handleToggle()}>Logout</Link>
                                </React.Fragment>
                            ) : null}
                            <div style={isOpen ? {"display":"flex", "flexWrap": "wrap", "justifyContent":"center"} : {}} className="dropdown">
                                {!isMobile && currentProfile && currentProfile.firstName ? (
                                    <Link className={isOpen ? "nav-links" : "w3-bar-item w3-button"} to={`/account/${currentProfile.sub}`} onClick={() => handleToggle()} style={{ "paddingRight": "0px" }}>{currentProfile.firstName}</Link>
                                ) : !isMobile && currentProfile && currentProfile.email ? (
                                    <Link className={isOpen ? "nav-links" : "w3-bar-item w3-button"} to={`/account/${currentProfile.sub}`} onClick={() => handleToggle()}>{currentProfile.email}</Link>
                                ) : null}
                                <button className="dropbtn" />
                                {/* Shows on Hover on Desktop */}
                                <div className="dropdown-content w3-white">
                                    {currentProfile ? (
                                        <React.Fragment>
                                            <Link to={`/account/${currentProfile.sub}`}>Account</Link>
                                            {currentProfile.isAdmin ? (
                                                <Link to="/users/privileges">User Privileges</Link>
                                            ): null}
                                            <Link to="/logout">Logout</Link>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            <Link to="/register" onClick={() => handleToggle()}>Register</Link>
                                            <Link to="/login" onClick={() => handleToggle()}>Login</Link>
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}

Navbar.propTypes = {
    isMobile: PropTypes.bool
};  

export default Navbar;